/* Remise par quantité (volume discount), 17/10/2026, demande de Larry (remplace BOGOS).
   Règles dans le metafield shop pmkt.remise_quantite (JSON) :
   { "regles": [ { "id": "quantite", "nom": "Remise quantité", "actif": true,
       "tag": "promo:quantite",          // les produits qui portent ce tag sont concernés
       "mix": "produit",                 // "produit" : tailles et couleurs d'un même produit se cumulent
                                         // "regle"   : tous les produits de la règle se cumulent
       "debut": null, "fin": null,       // dates ISO facultatives
       "mot": "veste", "mots": "vestes", // facultatif : « 2 vestes » au lieu de « 2 articles »
       "texte": "…",                     // facultatif : phrase sous les paliers de la fiche produit
       "paliers": [ { "qte": 2, "pct": 10 }, { "qte": 3, "pct": 15 } ] } ] }
   LE MÊME FICHIER est copié dans le thème (assets/pm-remise-quantite.js) : la fiche produit et le
   panier affichent exactement le calcul du checkout, qui reste seul juge (prix relus chez Shopify).
   Test : npm run test:quantite (vérifie aussi que les deux copies sont identiques). */
(function (racine, fabrique) {
  if (typeof module === "object" && module.exports) module.exports = fabrique();
  else racine.PMRemiseQuantite = fabrique();
})(typeof self !== "undefined" ? self : this, function () {
  var PCT_MAX = 50, QTE_MAX = 10;

  // Paliers propres : entiers, triés, sans doublon, plafonnés (une faute de frappe à 90 % ne passe pas).
  function paliersValides(r) {
    var vus = {}, out = [];
    (r && r.paliers || []).forEach(function (p) {
      var qte = parseInt(p && p.qte, 10), pct = Number(p && p.pct);
      if (!(qte >= 2 && qte <= QTE_MAX) || !(pct > 0 && pct <= PCT_MAX) || vus[qte]) return;
      vus[qte] = 1; out.push({ qte: qte, pct: Math.round(pct * 10) / 10 });
    });
    return out.sort(function (a, b) { return a.qte - b.qte; });
  }

  function active(r, maintenant) {
    if (!r || r.actif === false || !r.tag) return false;
    var t = maintenant || Date.now();
    if (r.debut && Date.parse(r.debut) > t) return false;
    if (r.fin && Date.parse(r.fin) <= t) return false;
    return paliersValides(r).length > 0;
  }

  // Première règle active qui vise un produit (par ses tags).
  function regleDuProduit(conf, tags, maintenant) {
    var regles = (conf && conf.regles) || [], tg = (tags || []).map(String);
    for (var i = 0; i < regles.length; i++)
      if (active(regles[i], maintenant) && tg.indexOf(String(regles[i].tag)) !== -1)
        return { id: String(regles[i].id || regles[i].tag), nom: regles[i].nom || "Remise quantité",
          mix: regles[i].mix === "regle" ? "regle" : "produit", paliers: paliersValides(regles[i]),
          mot: String(regles[i].mot || "article"), mots: String(regles[i].mots || "articles") };
    return null;
  }

  // Palier atteint pour une quantité (le plus haut), et le suivant (pour « encore 1 pour −15 % »).
  function palier(regle, qte) {
    var atteint = null, suivant = null;
    (regle && regle.paliers || []).forEach(function (p) {
      if (p.qte <= qte) atteint = p;
      else if (!suivant) suivant = p;
    });
    return { atteint: atteint, suivant: suivant };
  }

  // lignes : [{ pid, qty, price (XPF entiers), tags }]. Renvoie null ou
  // { montant, groupes: [{ regle, nom, qte, pct, base, montant, pids }] }.
  // Arrondi : une seule fois par groupe, à l'unité XPF (identique dans le thème).
  function calculer(lignes, conf, maintenant) {
    var groupes = {}, ordre = [];
    (lignes || []).forEach(function (l) {
      var r = regleDuProduit(conf, l.tags, maintenant);
      if (!r) return;
      var cle = r.mix === "regle" ? r.id : r.id + "|" + l.pid;
      if (!groupes[cle]) { groupes[cle] = { regle: r, qte: 0, base: 0, pids: [] }; ordre.push(cle); }
      var g = groupes[cle], q = Math.max(0, parseInt(l.qty, 10) || 0);
      g.qte += q; g.base += Math.round(Number(l.price) || 0) * q;
      if (g.pids.indexOf(l.pid) === -1) g.pids.push(l.pid);
    });
    var total = 0, out = [];
    ordre.forEach(function (cle) {
      var g = groupes[cle], p = palier(g.regle, g.qte).atteint;
      if (!p) return;
      var m = Math.round(g.base * p.pct / 100);
      if (m <= 0) return;
      total += m;
      out.push({ regle: g.regle.id, nom: g.regle.nom, mots: g.regle.mots, qte: g.qte, pct: p.pct, base: g.base, montant: m, pids: g.pids });
    });
    return total > 0 ? { montant: total, groupes: out } : null;
  }

  return { calculer: calculer, regleDuProduit: regleDuProduit, palier: palier,
    paliersValides: paliersValides, PCT_MAX: PCT_MAX, QTE_MAX: QTE_MAX };
});
